import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { ApplicationRoute, ModulesRoute } from '../../constants';

function setupAprovals(): void {
  applicationModuleRegistry.register({
    entry: 'approvals',
    id: 'approvals',
    name: 'modules.approvals',
    route: ModulesRoute.APPROVALS,
    closeable: true,
    routes: [
      {
        main: true,
        name: 'application.name',
        route: ApplicationRoute.APPROVAL_LIST,
        children: [
          {
            name: 'approvals.item.description',
            route: ApplicationRoute.APPROVAL_ITEM,
            children: [
              {
                name: 'approval.phases',
                route: ApplicationRoute.PURCHASE_APPROVAL,
              },
              {
                name: 'approval.phases',
                route: ApplicationRoute.OPINION_REQUEST,
              },
              {
                name: 'approval.phases',
                route: ApplicationRoute.INFORM_OPINION,
              },
              {
                name: 'approval.phases',
                route: ApplicationRoute.DISAPPROVE,
              },
              {
                name: 'approval.phases',
                route: ApplicationRoute.FORWARD,
              },
            ],
          },
        ],
      },
    ],
  });
}

export {
  setupAprovals,
};
